import React from 'react';

import { useTheme } from '../../theme/theming';

import Icon from '../../icon';

export default function QuotesComponent() {
  const theme = useTheme();
  return (
    <>
      <Icon
        width="28px"
        height="21px"
        name="Quote"
        color={theme?.colors?.icon}
      />
    </>
  );
}
